import TemplateView from '../../../TemplateView'
import messageResource from "../../../messageResource"
import LoadingSpinner from '../../../components/LoadingSpinner'
import {UserTeamAssignmentType} from '../constants'
import UserSelectorPanel from './UserSelectorPanel'
import LoadingContainer from '../../../util/LoadingContainer'
import {formatFmlWithCheck} from '../../../util/UserNameFormat'
import ScrollableContainer from '../../../util/ScrollableContainer'
import DisabledContainer from '../../../util/DisabledContainer'
import CopyContent from '../editTeamAssignmentsPanel/components/CopyContent'

class TeamAssignmentsPanelContent extends TemplateView {
    constructor({
        showCopyButton = true,
        onChangeDialogData = () => {},
        onCopyFromButtonClick = () => {},
        onBackButtonClick = () => {},
        onClickDialogContent = () => {},
        onCloseButtonClick = () => {},
    }) {
        super()

        this.state = {
            disabled: false,
            assignedUserIds: [],
            assignedGroupIds: [],
            users: [],
            userGroups: [],
            teamAssignmentType: UserTeamAssignmentType.SELECTED,
            hideNonSelected: false,
            userFML: {},
            userId: '',
            withBackButton: true,
            showCopyContent: false,
            copyContentLoading: false,
        }

        this.params = {
            showCopyButton,
            onChangeDialogData,
            onCopyFromButtonClick,
            onBackButtonClick,
            onClickDialogContent,
            onCloseButtonClick,
        }

        this.onStatePropertyChanged('disabled', disabled => this._updateDisabled(disabled))

        this.onStatePropertyChanged('teamAssignmentType', () => {
            this._updateRadio()
        })

        this.onStatePropertyChanged('userFML', () => {
            this._updateHeader()
        })

        this.onStatePropertyChanged('userId', () => {
            this.selectorPanel.resetFilters()
        })

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'assignedUserIds', 'assignedGroupIds', 'isUGREnabled'], () => {
            this.userSelectorPanel.setState({
                assignedUserIds: this.state.assignedUserIds,
                assignedGroupIds: this.state.assignedGroupIds,
                users: this.state.users,
                userGroups: this.state.userGroups,
                isUGREnabled: this.state.isUGREnabled,
            })
        })

        this.onAnyStatePropertyChanged(['teamAssignmentType', 'showCopyContent'], ({teamAssignmentType, showCopyContent}) => {
            const needToShowCopyContent = teamAssignmentType === UserTeamAssignmentType.SELECTED && showCopyContent
            this.$groupsList.toggle(!needToShowCopyContent)
            this.$copyContent.toggle(needToShowCopyContent)
            this.$copyButton.toggleClass('selected', needToShowCopyContent)
            this.$separator.toggleClass('invisible', needToShowCopyContent)
        })

        this.onStatePropertyChanged('withBackButton', (withBackButton) => {
            this.$backButton.toggle(withBackButton)
            this.$crossButton.toggle(!withBackButton)
        })

        this.onStatePropertyChanged('copyContentLoading', loading => this.copyContentWrapper.setState({loading}))
    }

    templateHtml() {
        return '<div class="teamAssignmentsPanel">' +
               '   <div class="header">' +
               '        <div class="updatingSpinner"/>' +
               '        <div class="backButton">' +
               '            <div class="arrow"></div>' +
               '            <div class="text"></div>' +
               '        </div>' +
               '        <div class="headerText"></div>' +
               '        <div class="crossButton"></div>' +
               '   </div>' +
               '   <div class="radioSection">' +
               '        <label>' +
               '            <div class="noAccessSection">' +
               '                <input type="radio" class="noAccess"/>' +
               '                <div class="icon"></div>' +
               '                <span><%-noAccessLabel%></span>' +
               '            </div>' +
               '        </label>' +
               '        <label>' +
               '            <div class="allSection">' +
               '                <input type="radio" class="selectAll"/>' +
               '                <div class="icon"></div>' +
               '                <span><%-selectAllLabel%></span>' +
               '            </div>' +
               '        </label>' +
               '        <label>' +
               '            <div class="customSection">' +
               '                <div class="option">' +
               '                    <input type="radio" class="customSelect"/>' +
               '                    <div class="icon"></div>' +
               '                    <span><%-customSelectLabel%></span>' +
               '                </div>' +
               '                <div class="vertical-separator"></div>' +
               '                <div class="copyButton">' +
               '                    <div class="copyButtonImg"/>' +
               '                    <div class="copyButtonLabel"><%-copyButtonLabel%></div>' +
               '                </div>' +
               '            </div>' +
               '        </label>' +
               '   </div>' +
               '   <div class="groupsList">' +
               '        <div class="groupsContent"/>' +
               '        <div class="moire"/>' +
               '   </div>' +
               '   <div class="copyContentPlaceholder"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            noAccessLabel: 'user.panel.permissions.team_assignments.no_users',
            selectAllLabel: 'user.panel.permissions.team_assignments.all_users',
            customSelectLabel: 'user.panel.permissions.team_assignments.selected_users',
            copyButtonLabel: 'management_assignment.panel.copy_button',
        }
    }

    afterRender() {
        this.$el.click((e) => {
            this.params.onClickDialogContent(e)
        })

        this.loadingSpinner = new LoadingSpinner().init(this.find('.updatingSpinner'))

        this.find('.backButton .text').text(messageResource.getMessage('user.panel.permissions.team_assignments.back'))
        this.$backButton = this.find('.backButton').on('click', () => {
            this.params.onBackButtonClick()
        })

        this.$crossButton = this.find('.crossButton').on('click', () => {
            this.params.onCloseButtonClick()
        })
        this.$crossButton.addClass('hideButton_panelContainer')

        this.$groupsList = this.find('.groupsList')
        this.$noAccessSection = this.find('.noAccessSection')
        this.$allSection = this.find('.allSection')
        this.$customSection = this.find('.customSection')
        this.$separator = this.find('.vertical-separator')
        this.$copyButton = this.find('.copyButton')
        this.$copyContent = this.find('.copyContentPlaceholder')

        this.$copyButton.toggle(this.params.showCopyButton)

        if (this.params.showCopyButton) {
            this.$copyButton.click(e => {
                if (this.state.teamAssignmentType === UserTeamAssignmentType.SELECTED) {
                    this.params.onCopyFromButtonClick()
                    e.stopPropagation()
                }
            })
        }

        this.$noAccessRadio = this.find('.noAccess').on('change', () => {
            this._handleChange({teamAssignmentType: UserTeamAssignmentType.NO})
        })

        this.$selectAllRadio = this.find('.selectAll').on('change', () => {
            this._handleChange({teamAssignmentType: UserTeamAssignmentType.ALL})
        })

        this.$customSelectRadio = this.find('.customSelect').on('change', () => {
            this._handleChange({teamAssignmentType: UserTeamAssignmentType.SELECTED})
        })

        this.selectorPanel = new UserSelectorPanel({
            onChange: ({assignedUserIds, assignedGroupIds}) => this._handleChange({assignedUserIds, assignedGroupIds})
        })

        this.userSelectorPanel = new LoadingContainer({
            contentComponent: this.selectorPanel,
            loadingMoireConfig: {
                delay: 500,
            }
        }).init(this.find('.groupsContent'))

        this.$headerText = this.find('.headerText')

        this.copyContent = new CopyContent({
            refreshScrollCb: () => this.copyContentScrollableWrapper.forceUpdate()
        })
        this.copyContentScrollableWrapper = new ScrollableContainer(null, this.copyContent, {triggerScrollEvent: false})
        this.copyContentWrapper = new DisabledContainer({
            contentComponent: new LoadingContainer({
                contentComponent: this.copyContentScrollableWrapper,
                containerClass: 'copyContentWrapper',
                loadingMoireConfig: {
                    delay: 500,
                }
            }),
            containerClass: 'copyContentWrapper',
        }).init(this.$copyContent)

        this.renderInitialState()
    }

    update() {
        super.update()
        this.selectorPanel.update()
    }

    _updateRadio() {
        this.$noAccessRadio.prop('checked', this.state.teamAssignmentType === UserTeamAssignmentType.NO)
        this.$selectAllRadio.prop('checked', this.state.teamAssignmentType === UserTeamAssignmentType.ALL)
        this.$customSelectRadio.prop('checked', this.state.teamAssignmentType === UserTeamAssignmentType.SELECTED)

        this.$noAccessSection.toggleClass('selected', this.state.teamAssignmentType === UserTeamAssignmentType.NO)
        this.$allSection.toggleClass('selected', this.state.teamAssignmentType === UserTeamAssignmentType.ALL)
        this.$customSection.toggleClass('selected', this.state.teamAssignmentType === UserTeamAssignmentType.SELECTED)
        this.$copyButton.toggleClass('disabled', this.state.teamAssignmentType !== UserTeamAssignmentType.SELECTED)

        this.$groupsList.toggleClass('notAvailable', this.state.teamAssignmentType !== UserTeamAssignmentType.SELECTED)
    }


    _handleChange = (changes) => {
        const state = {
            teamAssignmentType: this.state.teamAssignmentType,
            assignedGroupIds: this.state.assignedGroupIds,
            assignedUserIds: this.state.assignedUserIds,
        }

        this.params.onChangeDialogData({...state, ...changes})
    }

    _updateHeader() {
        this.$headerText.text(messageResource.getMessage('user.panel.permissions.team_assignments.title', [formatFmlWithCheck(this.state.userFML || {})]))
    }

    _updateDisabled(disabled) {
        this.loadingSpinner.setState({show: disabled})
        this.$selectAllRadio.prop('disabled', disabled)
        this.$customSelectRadio.prop('disabled', disabled)
        this.$noAccessRadio.prop('disabled', disabled)
        this.userSelectorPanel.setState({loading: disabled})
    }
}

export default TeamAssignmentsPanelContent



// WEBPACK FOOTER //
// ./web/js/panels/user/teamAssignmentsPanel/TeamAssignmentsPanelContent.js